const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

export interface StoredSessionTokens {
  accessToken: string;
  refreshToken?: string;
}

export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const storeSessionTokens = ({ accessToken, refreshToken }: StoredSessionTokens) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);

  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
};

export const clearSessionTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

type NavigateFn = (url: string) => void;

const defaultNavigate: NavigateFn = (url) => { window.location.assign(url); };

export const expireClientSession = (
  reason: 'expired' | 'unauthorized' = 'expired',
  navigate: NavigateFn = defaultNavigate,
) => {
  clearSessionTokens();
  navigate(`/login?reason=${reason}`);
};
